<template>
  <div class="wrapper">
    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100 align-middle">
        <div class="title">
          <h3>Site</h3>
        </div>
        <a href="#/site">
          <img
            src="@/assets/img/unidad-super-computo-cca.jpg"
            alt="Site"
            class="img-raised rounded  img-fluid"
          />
        </a>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100 align-middle">
        <div class="title">
          <h3>Clústeres</h3>
        </div>
        <a href="#/clusters">
          <img
            src="@/assets/img/clusters.jpg"
            alt="Clústeres"
            class="img-raised rounded  img-fluid"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import { Slider } from "@/components";
import { Badge } from "@/components";

export default {
  components: {},
  data() {
    return {
      defaultPagination: 3,
      infoPagination: 3,
      initial: null,
      floatingLabel: null,
      success: null,
      error: null,
      withMIcon: null,
      withFaIcon: null,
      checkbox1: true,
      checkbox2: null,
      checkbox3: true,
      checkbox4: null,
      radio1: true,
      radio2: false,
      switch1: true,
      switch2: null,
      amount: 30,
      amount2: 60,
      buffer: 40,
      sliders: {
        simple: 40,
        rangeSlider: [20, 60],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.vertical-center {
  display: flex;
  align-items: center;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.md-checkbox,
.md-radio {
  display: flex;
  margin: 0;
  margin-bottom: 0.5rem;
}
</style>
